import { EntityManager } from "@/components/EntityManager";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function Income() {
  return <EntityManager config={ENTITY_CONFIG.income} />;
}
